// extracted by mini-css-extract-plugin
module.exports = {"Input":"Checkbox_Input__2yI4X","Label":"Checkbox_Label__2Knb5","InputElement":"Checkbox_InputElement__aGdxH","Invalid":"Checkbox_Invalid__36tsJ"};